import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import Logo from "../../components/Logo";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pa_admin_token", data.token);
      navigate("/admin");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || "Грешка при вход");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><div className="inline-block bg-ivory px-4 py-3"><Logo /></div></div>
        <div className="bg-ivory p-8">
          <div className="flex items-center gap-2 text-navy mb-6"><Lock size={20} className="text-gold" /><h1 className="font-serif text-2xl">Админ панел</h1></div>
          <form onSubmit={submit} className="space-y-4">
            <input type="email" required placeholder="Имейл" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="admin-email" />
            <input type="password" required placeholder="Парола" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="admin-password" />
            {error && <p className="text-red-600 text-sm" data-testid="admin-error">{error}</p>}
            <button type="submit" disabled={loading} className="btn-gold w-full py-3 rounded-sm" data-testid="admin-login-btn">{loading ? "Влизане..." : "Вход"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
